import React from "react";
import { useLocation } from "react-router-dom";
import { SurveyWizard } from "../../components/survey/SurveyWizard";
import { treatments } from "../../utils/treatments";
import _ from "lodash";

// TODO: Refactor to bring Preliminary Survey for
// this and all treatments under one file e.g(Herpes)
const YeastPreliminarySurvey = () => {
  const yeastSearchableTag =
    process.env.REACT_APP_YEAST_PRELIMINARY_SURVEY_SEARCHABLE_TAG;

  const surveyPath = _.find(treatments, {
    searchable_tag: yeastSearchableTag,
  })?.href;

  return (
    <SurveyWizard
      surveySearchableTag={yeastSearchableTag}
      treatmentSurveyPath={surveyPath}
    />
  );
};

export default YeastPreliminarySurvey;
